import React from 'react'
import classNames from 'classnames'

// Chip + SectionLabel dùng chung cho các filter trong Danh Bạ — 1 cột, flex-wrap,
// copy đúng pattern của ChurchMassTimeFilter (views/AppLocals/Church/filters/ChurchMassTimeFilter.js)
// vì đó là bộ filter duy nhất không vỡ layout khi nhét vào panel hẹp (không dùng md:grid-cols).

export const Chip = ({active, onClick, children, className = ''}) => (
    <button
        type="button"
        onClick={onClick}
        style={{minHeight: 30}}
        className={classNames(
            'flex-shrink-0 flex items-center justify-center px-2.5 rounded-lg text-xs font-semibold transition-all cursor-pointer',
            active
                ? 'bg-orange-700 text-white'
                : 'bg-slate-50 text-slate-500 border border-slate-200 hover:border-orange-700 hover:text-orange-800',
            className
        )}>
        {children}
    </button>
)

export const SectionLabel = ({children}) => (
    <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
        {children}
    </span>
)
